var convertToYYYYMMDD = function (date) {
    if (date.getFullYear() < 2000) {
        date.setFullYear(date.getFullYear() + 100);
    }
    return date.toISOString().split('T')[0];
};
export var getDate = function () {
    var date = new Date();
    return convertToYYYYMMDD(date).replace(/-/g, '_');
};
var parseBlob = function (blobText, contentType) {
    return new Blob([blobText], { type: contentType });
};
var saveToFile = function (res, fileName) {
    var link = document.createElement('a');
    document.body.appendChild(link);
    link.setAttribute('style', 'display: none');
    var url = (window.URL || window.webkitURL).createObjectURL(res);
    link.href = url;
    link.download = fileName;
    link.click();
    setTimeout(function () {
        window.URL.revokeObjectURL(url);
        link.remove();
    }, 100);
};
export var saveFile = function (data, fileName, filetype) {
    var blob = parseBlob(data, "data:application/".concat(filetype, ","));
    return saveToFile(blob, fileName);
};
export var getFileName = function () { return "THD_USERS_".concat(getDate()); };
